import styles from './verify.module.css';
import Input from './input';
import Results from './results';
import { useState } from 'react';
import $ from 'jquery';

const Verify = () => {
    const [currentPage, setCurrentPage] = useState('input');
    const [resultObj, setResultObj] = useState({});

    function switchState(claim_text, inputType) {
        $.ajax({
            url : "http://localhost:5000/predict/",
            type : 'POST',
            contentType: "application/json",
            data : JSON.stringify({
                claim_text : claim_text,
                input_type : inputType
            }),
            async : false,
            success: function(data) {
                console.log(data);
                if(data) {
                    setResultObj(data);
                }
                else {
                    console.log("Server Error.");
                }
            },
            error: function(xhr, status, error) {
                console.log(error);
            }
        })
        setCurrentPage('results');
    }

    if(currentPage === 'input') {
        return (
            <div className = {styles.body}>
                <Input onClickHandler = {switchState}/>
            </div>
        )
    }

    else {
        return(
            <div className = {styles.body}>
                <Results resultObj = {resultObj}/>
            </div>
        )
    }
    
}

export default Verify;